import axios from "axios";

// const API_URL = "http://localhost:2707/";

// import Config from  '../../config';
import { SERVER_ } from  '../../config';

class AuthService {

  selectIsAuthenticated : Boolean = false;


  constructor(){
      // super();
      this.selectIsAuthenticated = this.IsAuthenticated()
  }


  login(username:String, password:String) {
    return axios
      .post( SERVER_ + "authenticate", {
        username,
        password
      })
      .then((response:any) => {
        if (response.data.accessToken) {
          localStorage.setItem("user", JSON.stringify(response.data.user));
          localStorage.setItem("rol", JSON.stringify(response.data.rol));
          localStorage.setItem("version_app", (response.data.version_app));
          localStorage.setItem("accessToken", JSON.stringify(response.data.accessToken));
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("user");
    localStorage.removeItem("rol");
    localStorage.removeItem("accessToken");
  }

  register(username:String, email:String, password:String) {
    return axios.post( SERVER_ + "signup", {
      username,
      email,
      password
    });
  }

  IsAuthenticated() {
    return (JSON.parse(localStorage.getItem('user')!)) ? true : false;
  }

  getCurrentUser() {
    const USUARIO = JSON.parse(localStorage.getItem('user')!)||{};
    // console.log(localStorage.getItem('rol'))
    USUARIO.role = localStorage.getItem('rol')
    return USUARIO
  }

  getToken(){
    return JSON.parse(localStorage.getItem('accessToken')!)
  }
}

// export default new AuthService();
const authService = new AuthService();
export default authService;